module.exports = __webpack_public_path__ + "static/media/komatsu-logo.37130546.png";